import {Injector, Pipe, PipeTransform, runInInjectionContext} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Route, Router, Routes} from '@angular/router';
import {ArrayUtil} from '../../../utils/array-util';
import {firstValueFrom, isObservable} from 'rxjs';
import {isCanActivate} from "../../../utils/guards.utils";

@Pipe({
    name: 'filterNavs'
})
export class FilterNavsPipe implements PipeTransform {

    constructor(private router: Router,
                private injector: Injector) {
    }


    transform(routes: Routes, deep: number): Promise<any>[] {
        if (!routes) {
            return null;
        }

        routes = ArrayUtil.oneToMany<Route>(routes);

        return routes.map(async (route) => {
            const hideNav = (route.path === '**' || route.data && route.data.navAutoHidden);
            if (hideNav) {
                return null;
            }

            const ignoreRouteCheck = route.data && (route.data.autoNavIgnoreGuard || route.data.navAutoHidden);
            if (ignoreRouteCheck || !route.canActivate) {
                return route;
            }

            const canActivate = await this.deduceCanActivate(route, deep);

            return canActivate ? route : null;
        });
    }

    deduceCanActivate = async (route: Route, deep: number): Promise<boolean> => {
        const canActivateResults = await Promise.all(route.canActivate.map(async (guard: any) => {

            let tGuardResult;
            const tGuard = this.injector.get(guard, null);
            const activatedRouteSnapshot = this.getFromRoot(this.router.routerState.snapshot.root, deep);
            if (isCanActivate(tGuard)) {
                tGuardResult = tGuard.canActivate(route, this.router.routerState.snapshot, activatedRouteSnapshot);
            } else {
                tGuardResult = runInInjectionContext(this.injector, () => guard(route, this.router.routerState.snapshot, activatedRouteSnapshot))
            }


            if (isObservable(tGuardResult)) {
                return firstValueFrom(tGuardResult);
            }
            return tGuardResult;
        }));

        return canActivateResults.every((canActivateResult) => !!canActivateResult);
    };

    private getFromRoot(root: ActivatedRouteSnapshot, deep: number): ActivatedRouteSnapshot {
        if (deep < 0) {
            return root;
        } else {
            return root && root.children && this.getFromRoot(root.children[0], --deep);
        }
    }
}
